<template>
  <CoreButton
    ref="button"
    class="mt-4 mb-8 self-start flex justify-center items-center"
    :class="[ suspense ? 'w-spinner' : 'w-submit']"
    :style="style"
    :disable-hover="suspense"
    @click.native="handleClick"
  >
    {{ suspense ? '' : 'Submit' }}
    <CoreSpinner v-if="suspense" />
  </CoreButton>
</template>

<script>
export default {
  name: 'CoreAsyncButton',

  props: {
    suspense: {
      type: Boolean,
      default: false,
    },
    ctaText: {
      type: String,
      default: 'Submit',
    },
  },

  data: () => ({
    width: null,
  }),

  computed: {
    style() {
      return {
        ...(!this.suspense && { width: this.width ? `${this.width}px` : 'unset' }),
      };
    },
  },

  mounted() {
    this.width = this.$refs.button.$el.offsetWidth;
  },

  methods: {
    handleClick(e) {
      e.preventDefault();
      this.$emit('click');
    },
  },
};
</script>

<style scoped>
.w-spinner {
  width: 8.5rem;
}
</style>
